import axios from "axios";
import swal from "sweetalert2";
import router from "../routes/router";
let  test
const util = {
  logoutOnRefresh() {
    console.log("logout");
    let jwtToken = JSON.parse(
      atob(sessionStorage.getItem("token").split(".")[1])
    );
    let id = jwtToken.employeeid;
    let options = Object.assign({}, options, {
      data: null,
      method: "GET"
    });
    sessionStorage.removeItem("token");
    let url = process.env.VUE_APP_API_URL + ":9992/auth/staff/logout/" + id;
    axios(url, options)
      .then(res => {
        console.log(res);
      })
      .catch(err => {
        console.log(err);
      });
  },
  stopPing(){
    clearInterval(test)
  },
  tokenPing() {
    console.log("token ping");

    if (sessionStorage.getItem("token") != null) {
      let jwtToken = JSON.parse(
        atob(sessionStorage.getItem("token").split(".")[1])
      );
      let id = jwtToken.employeeid;
      let options = Object.assign({}, options, {
        data: null,
        method: "GET"
      });

       test = setInterval(() => {
        let url =
          process.env.VUE_APP_API_URL + ":9992/auth/staff/tokencheck/" + id;
        axios(url, options)
          .then(res => {
            console.log(res.data.error);
            if (res.data.error) {
              sessionStorage.removeItem("token");
              clearInterval(test);
              swal({
                title: "Invalid session",
                text: "Session revoked , please relogin",
                type: "error",
                confirmButtonClass: "btn btn-success btn-fill",
                buttonsStyling: false
              })

              setTimeout(() => {
                router.push("/login");
                swal.close()
              },5000)
              //logout
            } else {
            }
          })
          .catch(err => {
            console.log(err);
          });
      }, 60000);
    }
  }
};

export default util;
